export default {
  bookExperiencePanel: 'Panel rezerwacji doświadczenia',
  calendarIcon: 'Ikona kalendarza',
  coverImageForResource: 'Zdjęcie okładkowe doświadczeń {{title}}',
  filterBy: 'Filtruj według {{filter}}',
  filterByDateRange: 'Filtruj według zakresu dat',
  gallery: 'Galeria',
  goBack: 'Powrót do poprzedniej strony',
  hostUserIcon: 'ikona użytkownika gospodarza',
  imageOf: 'Zdjęcie {{title}}',
  interactiveMapAltText: 'Interaktywna mapa z wybieralnymi {{title}}',
  mediaSlides: 'Slajdy multimedialne',
  muteVideo: 'Wycisz wideo',
  nextPhoto: 'Następne zdjęcie',
  noVideoPlayback: 'Brak możliwości odtwarzania wideo',
  pauseVideo: 'Wstrzymaj wideo',
  photoOf: 'zdjęcie {{name}}',
  playVideo: 'Odtwórz wideo',
  previousPhoto: 'Poprzednie zdjęcie',
  moreFiltersAndExperiences: 'Więcej filtrów i doświadczeń',
  reserveSelectedSlot: 'Zarezerwuj wybrany termin',
  reviewRating: 'Ocena recenzji {{rating}} z 5',
  overallReviewRating: 'Ogólna ocena recenzji {{rating}} z 5',
  selectCountryCodeForPhoneNumber: 'Wybierz kod kraju dla numeru telefonu',
  selectDate: 'Wybierz datę',
  selectParticipants: 'Wybierz uczestników',
  selectSessionTime: 'Wybierz godzinę sesji',
  unmuteVideo: 'Włącz dźwięk wideo',
  viewShoppingCart: 'Zobacz koszyk',
  itemsInCart: '{{count}} przedmiotów w koszyku',
  zoomIn: 'Przybliż',
  zoomOut: 'Oddal',
  selectData: 'Wybierz {{data}}',
  reserveName: 'Zarezerwuj {{name}}',
  deleteReservation: 'Usuń rezerwację {{experienceTitle}}',
  editParticipantsFor: 'Edytuj uczestników dla {{experienceTitle}}',
  enterPromoCode: 'Wprowadź kod promocyjny',
  applyPromoCode: 'Zastosuj kod promocyjny',
  increaseAddOnAmount: 'Zwiększ ilość wybranych {{addOn}}',
  decreaseAddOnAmount: 'Zmniejsz ilość wybranych {{addOn}}',
  addOnModal: 'Okno {{addOn}}',
  moreInformationAboutAddOn: 'Więcej informacji o {{addOn}}',
  decreasePriceTierTickets: 'Zmniejsz liczbę biletów {{priceTier}}',
  increasePriceTierTickets: 'Zwiększ liczbę biletów {{priceTier}}',
  downloadFilename: 'Pobierz {{filename}}',
  viewFullDetailsDescription: 'Zobacz pełny opis szczegółów',
  viewFullDescription: 'Zobacz pełny opis',
  closeModal: 'Zamknij okno',
  hyattBanner: 'Ekskluzywny baner World Of Hyatt dla członków',
  hyattBannerDesc:
    'Baner promocyjny informujący o ekskluzywnych korzyściach i ofertach dostępnych dla członków programu lojalnościowego World of Hyatt',
  previousSlide: 'Poprzedni slajd',
  nextSlide: 'Następny slajd',
  paginationBulletMessage: 'Przejdź do slajdu',
  exitFullscreen: 'Wyjdź z widoku pełnoekranowego',
  enterFullscreen: 'Włącz widok pełnoekranowy',
  videoSlide: 'Slajd wideo',
  imageSlide: 'Slajd ze zdjęciem',
  of: 'z',
  noDescription: 'Brak opisu',
  mediaGallery: 'Karuzela - Galeria multimediów',
  dateSelector: 'Wybór daty',
  nextWeek: 'Następny tydzień',
  previousWeek: 'Poprzedni tydzień',
  scheduleAgenda: 'Plan harmonogramu',
  scheduleNav: 'Nawigacja harmonogramu',
  scheduleViewSelector: 'Wybór widoku harmonogramu',
  selectedDateAriaLabel: '{{date}}, wybrano',
  tapToBookExperience: 'Zarezerwuj {{title}}',
  bookExperienceAriaLabel: 'Zarezerwuj {{title}}',
  joinWaitlistAriaLabel: 'Dołącz do listy oczekujących dla {{title}}',
};
